import { Component, OnInit, Input, OnDestroy, ViewChild } from "@angular/core";
import { environment } from "src/environments/environment";
import * as config from "../../../assets/grid_config.json";
import { BaseService } from "../base.service";
import { ContinueWatchingComponent } from "../content/continue-watching/continue-watching.component";
import { CountdownComponent } from "ngx-countdown";

@Component({
  selector: "app-grid",
  templateUrl: "./grid.component.html",
  styleUrls: ["./grid.component.css"],
})
export class GridComponent implements OnInit, OnDestroy {
  @Input() data: any;
  @Input() gridType: any;
  @Input() watchingStatus: any;
  @Input() status: any;
  @Input() type: any;
  @ViewChild("cd", { static: false }) private countdown: CountdownComponent;
  position: any = {};
  playerReady: any;
  modelData: any;
  app_constant: any;
  gridConfig: any = (config as any).default;

  constructor(
    public service: BaseService,
    public continueWatchingComponent: ContinueWatchingComponent
  ) {}

  ngOnInit(): void {
    this.app_constant = environment;
  }
  ngOnDestroy() {
    this.service.modelData = undefined;
    this.service.playerReady = false;
  }
  playOff() {
    this.service.playerReady = false;
  }
  handleEvent(evt: any, data: any) {
    if (evt.action == "done") {
      data["showTimer"] = true;
    }
  }
}
